import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.order');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-order',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.order/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageOrderComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public sub: string = '';
    public sectionTitle: string = '수불관리';
    public routerSub: any;

    public categories: any = {
        'inout': {
            label: '거래처 입출고관리',
            items: ['발주등록', '사입/반출등록', '발주대비 입고현황', '전표별 입출고내역', '상품별 입출고내역', '거래처정산관리']
        }
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.updateRoute();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.updateRoute();
                await this.service.render();
            }
        });
    }

    ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    private updateRoute() {
        const seg = WizRoute.segment;
        this.category = seg.category || 'inout';
        try { this.sub = seg.sub ? decodeURIComponent(seg.sub) : ''; } catch { this.sub = seg.sub || ''; }
        if (!seg.category) {
            this.service.href('/order/inout');
        }
    }

    public categoryKeys(): string[] {
        return Object.keys(this.categories);
    }

    public selectSub(item: string) {
        this.sub = item;
        this.service.render();
    }

    public isActiveCat(key: string): boolean {
        return this.category === key;
    }
}

export default PageOrderComponent;